import React from "react"
import AdminPanelDom from "../domains/adminPanel/adminPanelDom"

import AttributesPage from "./AttributesPage"

class AdminPanelAttributes extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({ MessaggiComponent }) => (
          <AttributesPage forAdmin={true} MessaggiComponent={MessaggiComponent} />
        )}
        {...this.props}
      />
    )
  }
}
export default AdminPanelAttributes
